import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import {
  selectSiteLoginColor,
  selectTopBaarBgColor,
} from "../../utils/helper/commonSelectors";
import { toggleRightSidebar } from "../../redux/slices/sidebarSlice";
import Minigames from "../Minigames";
import ExposureRightNavDrawer from "../DemoAccount/ExposureRightNavDrawer";
import { displayAuthModal } from "../../redux/slices/authModalSlice";

const ICONS = {
  home: "/Icon/home.svg",
  inplay: "/Icon/inplay.svg",
  miniGames: "/Icon/mini_games.gif",
  menu: "/Icon/menu.svg",
};

function BottomNavButton({ icon, label, onClick, to, isActivePath }) {
  const loginBtnColor = useSelector(selectSiteLoginColor);
  const location = useLocation(); // Add this

  const sharedStyle = {
    "--tw-gradient-from": loginBtnColor?.start || "#045662",
    "--tw-gradient-to": loginBtnColor?.end || "#045662",
  };

  const baseClasses =
    "w-full flex items-center justify-center space-x-2 px-6 py-2 rounded-full hover:bg-primary";

  const isActive =
    isActivePath?.(location.pathname) ||
    (to && location.pathname === to);

  if (to) {
    return (
      <li className="flex-1">
        <NavLink
          to={to}
          className={`${baseClasses} ${isActive ? "text-yellow-400 font-bold" : "text-white"}`}
          style={{ ...sharedStyle, backgroundColor: isActive ? "#0F172A" : "transparent" }}
        >
          <img src={icon} className="w-[25px]" alt={`${label} icon`} />
          {isActive && <span className="text-xs" style={{ whiteSpace: "nowrap" }}>{label}</span>}
        </NavLink>
      </li>
    );
  }

  return (
    <li className="flex-1">
      <button
        className={`${baseClasses} text-white`}
        style={sharedStyle}
        onClick={onClick}
        aria-label={label}
      >
        <img src={icon} className="w-[25px]" alt={`${label} icon`} />
      </button>
    </li>
  );
}



export default function MobileBottomBar() {
  const dispatch = useDispatch();
  let isLoggedIn = useSelector((state) => state?.user?.isLoggedIn);
  const loggedInUserType = useSelector((state) => state?.user?.loggedInType);
  // isLoggedIn = isLoggedIn && loggedInUserType === "real";
  const TopBaarBgColor = useSelector(selectTopBaarBgColor());
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showMinigames, setShowMinigames] = useState(false);

  const setShowModal = (modalname) => {
    dispatch(displayAuthModal(modalname))
  }
  
  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    dispatch(toggleRightSidebar());
  };

  return (
    <>
      <nav
        className="fixed z-40 bottom-0 left-0 right-0 text-white sm:hidden rounded-t-lg h-[48px]"
        aria-label="Mobile Bottom Navigation"
      >
        <ul className="flex justify-between items-center p-2 py-1.5 font-bold"
          style={{
            backgroundImage: `linear-gradient(${TopBaarBgColor.start}, ${TopBaarBgColor.start})`,
          }}
        >
          {/* Home */}
          <BottomNavButton
            icon={ICONS.home}
            label="Home"
            to={isLoggedIn && loggedInUserType === "real" ? "/user" : "/demo"}
            isActivePath={(path) => ["/", "/user", "/demo"].includes(path)}
          />

          {/* In-Play */}
          <BottomNavButton
            icon={ICONS.inplay}
            label="In-Play"
            to="in-play"
            isActivePath={(path) => ["/in-play"].includes(path)}
          />

          {/* Games */}
          <BottomNavButton
            icon={ICONS.miniGames}
            label="Games"
            to="live-casino"
            onClick={() => setShowMinigames((prev) => !prev)}
            isActivePath={(path) => ["/live-casino"].includes(path)}
          />

          {/* Menu */}
          <BottomNavButton
            icon={ICONS.menu}
            label="Menu"
            onClick={() => {
              if (isLoggedIn) {
                handleToggleDrawer();
              } else {
                setShowModal("login")
              }
            }}
            showLabel
          />
        </ul>
      </nav>

      {/* Conditionally Render Mini Games */}
      {showMinigames && <Minigames />}

      {/* Conditionally Render Drawer */}
      {isLoggedIn && (
        <ExposureRightNavDrawer
          isOpen={isDrawerOpen}
          toggleDrawers={handleToggleDrawer}
        />
      )}
    </>
  );
}
